<div style="height: calc(100vh - 417px);" class="d-flex justify-content-center text-center align-items-center component">
   <div class="container-fluid">
      <h1>
         {{ error_code }}: <span translate>ERROR.{{ error_code }}.TITLE</span>
      </h1>
      <!-- <p translate>ERROR.{{ error_code }}.SUBTITLE</p> -->
   </div>
</div>
